"use client";
import Input from "@/components/form/input/InputField";
import Label from "@/components/form/Label";
import Button from "@/components/ui/button/Button";
// removed unused imports
import React, { useState } from "react";
import { useAuthActions } from "@convex-dev/auth/react";

export default function SignInForm() {
	const { signIn } = useAuthActions();
	const [email, setEmail] = useState("");
	const [magicStatus, setMagicStatus] = useState<
		"idle" | "sending" | "sent" | "error"
	>("idle");
	const [magicError, setMagicError] = useState<string | null>(null);
	return (
		<div className="flex flex-col flex-1 lg:w-1/2 w-full">
			<div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
				<div>
					<div className="mb-5 sm:mb-8">
						<h1 className="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
							Sign In
						</h1>
						<p className="text-sm text-gray-500 dark:text-gray-400">
							Enter your email to receive a magic sign-in link.
						</p>
					</div>
					<div className="grid grid-cols-1 gap-3 sm:grid-cols-1 sm:gap-5">
						<button
							className="inline-flex items-center justify-center gap-3 py-3 text-sm font-normal text-gray-700 transition-colors bg-gray-100 rounded-lg px-7 hover:bg-gray-200 hover:text-gray-800 dark:bg-white/5 dark:text-white/90 dark:hover:bg-white/10"
							onClick={() =>
								void signIn("microsoft-entra-id", {
									redirectTo: "/dashboard/auditor",
								})
							}>
							<svg
								width="20"
								height="20"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path d="M11 3H3v8h8V3z" fill="#F25022" />
								<path d="M21 3h-8v8h8V3z" fill="#7FBA00" />
								<path d="M11 13H3v8h8v-8z" fill="#00A4EF" />
								<path d="M21 13h-8v8h8v-8z" fill="#FFB900" />
							</svg>
							Sign in with Microsoft
						</button>
					</div>
					<div className="relative py-3 sm:py-5">
						<div className="absolute inset-0 flex items-center">
							<div className="w-full border-t border-gray-200 dark:border-gray-800"></div>
						</div>
						<div className="relative flex justify-center text-sm">
							<span className="p-2 text-gray-400 bg-white dark:bg-gray-900 sm:px-5 sm:py-2">
								Or
							</span>
						</div>
					</div>
					<form onSubmit={(e) => e.preventDefault()}>
						<div className="space-y-6">
							<div>
								<Label>
									Email <span className="text-error-500">*</span>{" "}
								</Label>
								<Input
									name="email"
									type="email"
									placeholder="info@gmail.com"
									onChange={(e) => setEmail(e.target.value)}
								/>
							</div>
							<div>
								<Button
									className="w-full"
									size="sm"
									disabled={magicStatus === "sending" || !email}
									onClick={async () => {
										setMagicStatus("sending");
										setMagicError(null);
										try {
											const formData = new FormData();
											formData.set("email", email);
											// pass redirectTo to control post-auth landing page
											formData.set("redirectTo", "/dashboard/auditor");
											await signIn("microsoft-graph", formData);
											setMagicStatus("sent");
										} catch (err) {
											setMagicStatus("error");
											setMagicError(
												err instanceof Error
													? err.message
													: "Failed to send magic link"
											);
										}
									}}>
									{magicStatus === "sending" ? "Sending…" : "Send magic link"}
								</Button>
							</div>
							{magicStatus === "sent" && (
								<p className="text-xs text-green-600">
									Magic link sent. Check your email.
								</p>
							)}
							{magicStatus === "error" && (
								<p className="text-xs text-red-600">
									{magicError ?? "Something went wrong."}
								</p>
							)}
						</div>
					</form>
				</div>
			</div>
		</div>
	);
}
